// Static site content for California Mobile VIN Verification.
// Shared business details used across the public site.

export const BUSINESS = {
  name: "The VIN Verifier",
  owner: "Bruna",
  tagline: "California Licensed Vehicle Verifier",
  phone: "(657) 768-6189",
  phoneHref: "tel:+16577686189",
  email: "contact@thevinverifierca.com",
  hours: "Mon–Sat · 7:00 AM – 8:00 PM",
  license: "California Licensed · Verified & Bonded",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Areas", href: "#areas" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "reg-vin",
    title: "Out-of-State VIN Verification",
    desc: "REG 31 verification for vehicles registered outside California — completed quickly and correctly.",
    span: "lg:col-span-8",
    tall: true,
  },
  {
    id: "dmv",
    title: "DMV REG 31 Form",
    desc: "Official, signed, and ready for submission.",
    span: "lg:col-span-4",
  },
  {
    id: "trailer",
    title: "Trailers & Motorcycles",
    desc: "Specialty verification for two-wheelers, trailers and RVs.",
    span: "lg:col-span-4",
  },
  {
    id: "fleet",
    title: "Dealer & Fleet Accounts",
    desc: "Volume verification for dealerships, auctions and commercial fleets. Discounts for 5+ vehicles.",
    span: "lg:col-span-4",
  },
  {
    id: "mobile",
    title: "Mobile Service",
    desc: "We come to you anywhere nearby — call for a quick quote based on your location.",
    span: "lg:col-span-4",
  },
];

export const PRICING = [
  { name: "Cars, SUVs & Light Trucks", price: "Call for a Quote", note: "Tell us your vehicle and location for a fast, upfront quote. A travel fee may apply." },
  { name: "Trailers, RVs & Specialty Vehicles", price: "Call for a Quote", note: "Pricing depends on vehicle type, access and travel distance. We confirm the total before your appointment." },
  { name: "Dealer, Commercial & Fleet", price: "Call for a Quote", note: "Custom per-vehicle pricing and volume discounts are available for qualifying appointments." },
];

export const REGIONS = [
  {
    name: "Orange County",
    cities: ["Anaheim", "Santa Ana", "Irvine", "Huntington Beach", "Costa Mesa", "Fullerton", "Orange", "Garden Grove", "Tustin", "Newport Beach"],
  },
  {
    name: "Los Angeles Area",
    cities: ["Los Angeles", "Long Beach", "Pasadena", "Glendale", "Torrance", "Downey", "Norwalk", "Whittier", "Cerritos", "Santa Clarita"],
  },
  {
    name: "Inland Empire",
    cities: ["Riverside", "San Bernardino", "Ontario", "Rancho Cucamonga", "Fontana", "Corona", "Moreno Valley", "Temecula", "Chino", "Redlands"],
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "California Licensed & Bonded",
    body: "Every verification is performed by a California state-licensed vehicle verifier. Your REG 31 is completed correctly the first time — no rejected paperwork, no return trips to the DMV.",
  },
  {
    n: "02",
    title: "We Come To You",
    body: "Home, office, storage lot or curbside — a certified verifier arrives at the location of your choice throughout Orange County, the Los Angeles area and the Inland Empire.",
  },
  {
    n: "03",
    title: "Precise & Trusted",
    body: "Odometer, federal label, engine and chassis numbers — documented with meticulous accuracy. Thousands of California drivers, dealers and fleets rely on us every year.",
  },
];

export const REVIEWS = [
  { name: "Marcus T.", city: "Huntington Beach", text: "Booked in the morning, verified by noon. Bruna had my REG 31 accepted at the DMV with zero issues. Effortless and professional." },
  { name: "Priya S.", city: "San Jose", text: "I moved from Texas and dreaded the VIN verification. Bruna made it painless — quick, friendly and clearly knew the paperwork inside out." },
  { name: "Danielle R.", city: "Irvine", text: "Bruna was patient, thorough and on time. Explained every step and the REG 31 was flawless. Highly recommend The VIN Verifier." },
  { name: "Kevin O.", city: "Long Beach", text: "Verified several dealer vehicles in one visit. Clean invoicing, punctual, and genuinely pleasant to work with." },
  { name: "Amara N.", city: "Anaheim", text: "The gold standard for VIN checks in the area. Bruna texted me an arrival window and it was smooth from start to finish." },
];

export const FAQS = [
  { q: "What is a VIN verification and when do I need one?", a: "California requires a VIN verification (REG 31) when registering an out-of-state vehicle or certain vehicles missing prior California registration. A licensed verifier confirms the VIN matches the vehicle and paperwork." },
  { q: "Where do verifications take place?", a: "We provide mobile service at your home, workplace, dealership or storage location throughout Orange County, the Los Angeles area and nearby Inland Empire cities. Call (657) 768-6189 for an upfront quote; a travel fee may apply based on distance." },
  { q: "Do you verify salvage or rebuilt vehicles?", a: "No. We do not currently handle salvage or rebuilt-title vehicles. We focus on standard out-of-state, dealer, fleet and specialty (motorcycle/trailer) verifications." },
  { q: "How long does the verification take?", a: "Most verifications take 15–20 minutes. You receive your completed and signed REG 31 form immediately, ready for DMV submission." },
  { q: "What do I need to have ready?", a: "The vehicle and your out-of-state title or registration. We'll confirm anything else you need when you book." },
  { q: "Which vehicles can you verify?", a: "Cars, SUVs, light and heavy trucks, motorcycles, trailers and RVs. Dealer and fleet accounts are welcome — with discounts for 5 or more vehicles." },
  { q: "How do I pay?", a: "Payment is collected after the verification is complete. We accept cash, Zelle, and major credit cards (a processing fee applies to cards). Dealer and fleet accounts can be invoiced." },
];

export const SERVICE_OPTIONS = [
  "Cars / SUVs / Light Trucks",
  "Motorcycle / Trailer",
  "Dealer / Fleet",
  "Mobile Service (call for quote)",
];

export const IMAGES = {
  hero: "/vin-verification-hero.jpg",
  verify: "/vin-verification-detail.jpg",
  areas: "https://images.unsplash.com/photo-1767681774518-dc28fec12c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxjYWxpZm9ybmlhJTIwaGlnaHdheSUyMGR1c2slMjByb2FkfGVufDB8fHx8MTc4NDc3MTYxM3ww&ixlib=rb-4.1.0&q=85",
};
